export const GET_ALL_BILL_REQUEST = 'GET_ALL_BILL_REQUEST'
export const GET_ALL_BILL_SUCCESS = 'GET_ALL_BILL_SUCCESS'
export const GET_ALL_BILL_FAIL = 'GET_ALL_BILL_FAIL'

export const GET_ALL_BOOKING_REQUEST = 'GET_ALL_BOOKING_REQUEST'
export const GET_ALL_BOOKING_SUCCESS = 'GET_ALL_BOOKING_SUCCESS'
export const GET_ALL_BOOKING_FAIL = 'GET_ALL_BOOKING_FAIL'